import { Attributes, DateUtils, Misc, Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class InvestmentRateChangeCriteria extends Model.CriteriaBase {

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    public entityId: number | null = null;

    public interestRateTypeId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investment Rate Change Criteria";
    }
}